/* istanbul ignore file -- remove once added tests */
import clsx from "clsx";
import styles from "./ImageTile.module.css";
export function ImageTile(props) {
    const { height } = props;
    const style = {
        ...(height ? { height } : {}),
    };
    return (<div className={clsx(styles.tileContainer)}>
      {props.imageSrc && (<div className={styles.imageWrapper} style={style}>
          <img className={clsx(styles.tileMedia)} height={props.height} width={props.width} src={props.imageSrc} alt={props.alt || ""} loading={props.lazy ? "lazy" : "eager"}/>
        </div>)}
      {/* Children are rendered as an overlay above the tile */}
      <div className={styles.overlay}>{props.children}</div>
    </div>);
}
